import {SearchSlide} from './search_slide/search_slide_block';
import './search_container.css';

export const SearchRoutesContainer = {
    components: {
        SearchSlide
    },
    props: {},
    created()
    {
    },
    data(): object {
        return {}
    },
    mounted() {
    },
    beforeUnmount() {
    },
    methods: {},
    template: `
        <SearchSlide />
    `
}